import { render, staticRenderFns } from "./InvoicesControlRX.vue?vue&type=template&id=a71df558&scoped=true&"
import script from "./InvoicesControlRX.vue?vue&type=script&lang=js&"
export * from "./InvoicesControlRX.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesControlRX.vue?vue&type=style&index=0&id=a71df558&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71df558",
  null
  
)

export default component.exports